module.exports = __webpack_public_path__ + "static/media/PTMP Explainer Video Script Final_1741201170206.5a0d146d.docx";